import {
  Alert,
  Box,
  Card,
  CircularProgress,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { SyntheticEvent, useState } from "react";
import Layout from "components/Layout";
import FeatureFlags from "components/settings/FeatureFlags";
import ReportCache from "components/settings/ReportCache";
import { useAuth } from "features/store";
import { useGetUserQuery } from "features/auth/auth";
import {
  MANAGE_FEATURE_FLAGS_PERMISSION,
  useHasPermission,
} from "features/auth/permissions";

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { user, isLoading, isAuthenticated } = useAuth();
  const { isError: userFailed } = useGetUserQuery();
  const canManageFeatureFlags = useHasPermission(
    MANAGE_FEATURE_FLAGS_PERMISSION,
  );

  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  // Until the user has loaded nothing is known either way, so neither the
  // settings nor a refusal is shown yet. A user that failed to load (or a
  // signed-out visitor, whom the side menu sends to /login) falls through to
  // the refusal rather than spinning forever.
  if (!user && !userFailed && (isLoading || isAuthenticated)) {
    return (
      <Layout title="Settings">
        <Box display="flex" justifyContent="center" py={6}>
          <CircularProgress aria-label="Loading" />
        </Box>
      </Layout>
    );
  }

  if (!canManageFeatureFlags) {
    return (
      <Layout title="Settings">
        <Alert severity="error" sx={{ m: 1 }}>
          You do not have permission to view Settings.
        </Alert>
      </Layout>
    );
  }

  return (
    <Layout title="Settings">
      <Card>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="General" />
          <Tab label="Feature Flags" />
          <Tab label="Cache" />
        </Tabs>
        <Grid container>
          {activeTab === 0 && (
            <Grid item xs={12} padding={2}>
              <Typography variant="body2" color="text.secondary">
                No general settings yet.
              </Typography>
            </Grid>
          )}
          {activeTab === 1 && (
            <Grid item xs={12} padding={2}>
              <FeatureFlags />
            </Grid>
          )}
          {activeTab === 2 && (
            <Grid item xs={12} padding={2}>
              <ReportCache />
            </Grid>
          )}
        </Grid>
      </Card>
    </Layout>
  );
};

export default SettingsPage;
